
























import { ACTION_GET_OFFICE_USERS } from '@/store/modules/generic';

export default {
    props: {
        value: {
            default: () => [],
        },
        disable: {
            type: Boolean,
            default: false,
        },
        multiple: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            loading: false,
        };
    },

    methods: {
        async remoteMethod(this: any, query: string) {
            if (query !== '' && query.length > 2) {
                this.loading = true;
                await this.$store.dispatch(ACTION_GET_OFFICE_USERS, query);
                this.loading = false;
            }
        },
    },
    computed: {
        options(this: any) {
            let searchedUsers = this.$store.getters.officeUsers
                .map((q: any) => ({
                    value: q.UserPrincipalName,
                    label: (q.GivenName && q.Surname) ? `${q.GivenName} ${q.Surname}` : q.DisplayName,
                    phone: q.MobilePhone,
                }))
                .filter((q: any) => q.value && q.label);

            // adding already selected users data to display properly
            if (this.multiple) {
                const notInList = this.ownerVal.filter(
                    (q: any) => !searchedUsers.some(
                        (s: any) => s.value.toLowerCase() === q.value.toLowerCase(),
                    ),
                );
                searchedUsers = searchedUsers.concat(notInList);
            }
            return searchedUsers;
        },
        ownerVal: {
            get(this: any) {
                return this.value;
            },
            set(this: any, val: any) {
                this.$emit('input', val);
            },
        },
    },
};
